import config from 'Cloud/config';
import { csvMaxEditableSize } from 'reactApp/appHelpers/featuresHelpers/features/canOpenCsv';
import { FileType } from 'reactApp/types/FileType';

export const ITEM_WITHOUT_HASH_MAX_SIZE = config.get('ITEM_WITHOUT_HASH_MAX_SIZE');

export const canOpenSmallFile = (item) => {
    const { size = 0, ext } = item;

    let canOpen = size > (ITEM_WITHOUT_HASH_MAX_SIZE ?? 0);

    if (ext === FileType.CSV && csvMaxEditableSize) {
        canOpen = size < csvMaxEditableSize;
    }

    return canOpen;
};
